import React from "react";
import "./NotificationBadge.css";

/**
 * NotificationBadge
 * Props:
 *   count    — number of unread notifications
 *   isOpen   — boolean, whether the panel is open
 *   onClick  — handler to toggle the panel
 */
const NotificationBadge = ({ count = 0, isOpen = false, onClick }) => {
  return (
    <button
      className={`nb-btn${isOpen ? " nb-btn--active" : ""}`}
      onClick={onClick}
      aria-label={`Notifications${count > 0 ? `, ${count} unread` : ""}`}
      aria-expanded={isOpen}
      aria-haspopup="dialog"
    >
      <img
        src="/images/notification.png"
        alt=""
        aria-hidden="true"
        className="nb-icon"
      />
      {count > 0 && (
        <span className="nb-badge" aria-hidden="true">
          {count > 99 ? "99+" : count}
        </span>
      )}
    </button>
  );
};

export default NotificationBadge;
